import Alert from '@mui/material/Alert';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { sumLengths } from '@openx/utils/lib/sumLengths.ts';
import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import type { InvalidItemsError } from '../types.ts';
import { AlertAction } from './components/AlertAction.tsx';
import { ErrorDetails } from './components/ErrorDetails.tsx';

interface ItemsOverLimitProps {
  errorText?: string;
  errors: InvalidItemsError[];
}

export function InvalidItems(props: ItemsOverLimitProps) {
  const { errorText, errors } = props;
  const { t } = useTranslation();
  const [showErrors, setShowErrors] = useState(false);

  const nonValidItems = useMemo(() => sumLengths(errors, error => error.invalidItems.length), [errors]);

  const itemText = nonValidItems > 1 ? t('items were') : t('item was');

  return (
    <Box sx={theme => ({ width: '100%', mr: 1, backgroundColor: theme.palette.error.light })}>
      <Alert
        severity="error"
        action={<AlertAction showErrors={showErrors} setShowErrors={setShowErrors} />}
        data-test="invalid-items-bulk-message"
        sx={{
          alignItems: 'center',
        }}
      >
        <Typography variant="body1">
          <b>{t('{num} {itemText} removed', { itemText, num: nonValidItems })}</b>
        </Typography>
      </Alert>

      <Box sx={{ pr: 2, pl: 2 }}>
        {showErrors && errorText ? <Typography variant="body1">{errorText}</Typography> : null}
        {showErrors && <ErrorDetails errors={errors} />}
      </Box>
    </Box>
  );
}
